import { Component, EventEmitter, Input, OnInit, Output, Inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MenuOption } from '../models/menu-option';
import { ProfessionType } from '../models/profession-type';
import { SpecialtyService } from '../services/specialty/specialty.service';

@Component({
    selector: 'lib-specialty-dropdown',
    templateUrl: './specialty-dropdown.component.html',
    styleUrls: ['./specialty-dropdown.component.scss'],
    standalone: false
})
export class SpecialtyDropdownComponent implements OnInit {
  @Input() defaultOption?: MenuOption;
  @Input() disabled: boolean = false;
  @Input() error?: string;
  @Input() excludeUserSpecialties: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() isInvalid: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() name: string;
  @Input() placeholder: string = 'Select Specialty';
  @Input() showTitle: boolean = true;
  @Input() title?: string;
  @Input() trackingIdPrefix?: string = 'resolve';
  @Input() userSpecialties?: string[];
  @Input() profession?: ProfessionType = null;
  @Input() boldTitle: boolean = false;

  @Output() optionSelected = new EventEmitter<MenuOption>();

  options$: Observable<MenuOption[]>;

  constructor(
    @Inject('SpecialtyService') private specialtyService: SpecialtyService
  ) { }

  ngOnInit() {
    let userSpecialtyOptions = []
    if (!!this.userSpecialties) {
      userSpecialtyOptions = this.userSpecialties.map(specialty => {
        return {label: specialty, value: specialty} as MenuOption
      })
    }
    if (!this.excludeUserSpecialties) {
      this.options$ = this.specialtyService.getMGMASpecialtiesAsMenuOptions(this.profession).pipe(
        map(options => options.filter(option => !this.userSpecialties?.includes(option.value))),
        map(options => [...userSpecialtyOptions, ...options])
      );
    } else {
      this.options$ = this.specialtyService.getMGMASpecialtiesAsMenuOptions(this.profession);
    }

      if (this.defaultOption) {
        this.optionSelected.emit(this.defaultOption);
      }
  }

  handleSelection(selectedOption: MenuOption) {
    this.optionSelected.emit(selectedOption);
  }

}
